import React, { useCallback } from 'react';
import { mapModifiers, ModifierProp } from 'libs/component';
import { useTranslation } from 'react-i18next';

export interface PoiCardProps {
  value: string;
  image: string;
  imageSp: string;
  imageWebp?: string;
  imageWebpSp?: string;
  title: string;
  summary?: string;
  distance?: React.ReactNode;
  modifiers?: ModifierProp<'hotel' | 'surrounding'>;
  onClick?: (value: string) => void;
}

export const PoiCard: React.FC<PoiCardProps> = ({
  value,
  image,
  imageSp,
  imageWebp,
  imageWebpSp,
  title,
  summary,
  distance,
  modifiers,
  onClick,
}) => {
  const { i18n } = useTranslation();

  const handleOnClick = useCallback(() => {
    if (onClick) {
      onClick(value);
    }
  }, [onClick, value]);
  return (
    <div className={mapModifiers('a-poi-card',
      modifiers,
      i18n.language,
      `v-${value}`,
    )} onClick={handleOnClick}>
      <div className="a-poi-card__top">
        <figure className="a-poi-card__image">
          {image && (
            <picture>
              {imageSp && (
                <>
                  {imageWebpSp && <source media="(max-width: 640px)" srcSet={imageWebpSp} type="image/webp" />}
                  {imageWebp && <source media="(min-width: 641px)" srcSet={imageWebp} type="image/webp" />}
                  {imageSp && <source media="(max-width: 640px)" srcSet={imageSp} />}
                  <source media="(min-width: 641px)" srcSet={image} />
                </>
              )}
              <img src={image} alt={title as string} width="309" height="232" />
            </picture>
          )}
        </figure>
        <div className="a-poi-card__distance">{distance}</div>
      </div>
      <div className="a-poi-card__bottom">
        <div
          className="a-poi-card__title"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        {summary && (
          <div className="a-poi-card__summary">
            <p
              className="a-poi-card__summary-text"
              dangerouslySetInnerHTML={{
                __html: summary,
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
